import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DemoStateModel } from '../../types/demoModels';

const initialDemoState: DemoStateModel = {
  count: 0,
  color: '#fff',
};

const demoSlice = createSlice({
  name: 'demo',
  initialState: initialDemoState,
  reducers: {
    setCount(state, action: PayloadAction<any>) {
      state.count = action.payload;
    },
    increaseCount(state) {
      state.count = state.count + 1;
    },
    decreaseCount(state) {
      state.count = state.count - 1;
    },
    setColor(state, action: PayloadAction<any>) {
      state.color = action.payload;
    },
    clearDemo(state) {
      state.count = 0;
      state.color = '#fff';
    },
  },
});

export default demoSlice;
